import axios from "axios";
import * as actionType from "../../constant/actionType";
export const DeleteProviderContact = (ApiData) => async (dispatch) => {
      try {
        const response = await axios({
          method: 'delete',
          data: {individual_org_id:ApiData},
          headers: {
            Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
          },
          url: `${actionType.environment_url}/api/admin/provider/DeleteProviderContact`,
        });
        return response.data
      } catch (error) {
        return error.message
      }
    }